import type { SVGProps } from 'react';
import * as React from 'react';

const SvgLinkBroken01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 4V2m6 18v2M4 9H2m18 6h2M4.914 4.914 3.5 3.5m15.586 15.586L20.5 20.5M12 17.657l-2.121 2.121a4 4 0 1 1-5.657-5.657L6.343 12m11.314 0 2.121-2.121a4 4 0 1 0-5.657-5.657L12 6.343"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgLinkBroken01;
